export function getInitials(name: string) {
  const initials = name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

  if (!initials) return "";

  if (initials.length === 1) {
    return initials[0].toUpperCase();
  } else {
    return (initials[0] + initials[initials.length - 1]).toUpperCase();
  }
}
